const strings = {
  EDIT_LAUNDRY_TIME: 'Ändra en tvättid',
  EDIT_LAUNDRY_TIME_INFORMATION:
    'Ställ in en ny start -och sluttid för att ändra tvättiden.',
  MANDATORY_FIELD: 'Fältet är oblikatoriskt',
  LAUNDRY_TIME_UPDATED: 'Tvättiden har uppdaterats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditLaundryTimeModal/strings.js